import { useMemo, useState } from "react";

import { QUERY_KEYS } from "@/src/config";
import { dayjs } from "utils";
import { returnZeroIfInvalidNumber } from "@/src/utils/portfolio";
import { rootStore } from "@/src/store";
import { useOspApiClientProvider } from "@/src/hooks";
import { useQuery } from "@tanstack/react-query";
import { useSnapshot } from "valtio/react";

export const useHistory = ({ id, value }: { id: string; value?: number }) => {
  const { memberApi } = useOspApiClientProvider();
  const { isLoggedIn } = useSnapshot(rootStore.login);
  const [period, setPeriod] = useState<string>("1d");
  const { data, isFetching } = useQuery({
    // 获取history 图表
    queryKey: [
      QUERY_KEYS.PORTFOLIO_PERFORMANCE,
      id,
      "VALUE",
      period,
      value?.toFixed?.(2),
    ],
    enabled: isLoggedIn && !!memberApi,
    staleTime: 30 * 60 * 1000, // 30 minutes
    queryFn: async () => {
      const res = await memberApi?.positions.getOwnerPositionSummary({
        with_position_performance: true,
        performance_type: "VALUE",
        performance_period: period,
      });
      return res?.data?.data?.position_performance?.points;
    },
  });
  const history = useMemo(() => {
    const yesterdayStartUTC = dayjs()
      .utc()
      .subtract(1, "day")
      .startOf("day")
      .valueOf();
    const lastDataPoint = data?.at(-1);
    if (!lastDataPoint?.time || lastDataPoint.time < yesterdayStartUTC) {
      return {
        XAxis: [],
        valueData: [],
      };
    }
    const XAxis: { x: number; label: string }[] = [];
    const valueData: number[] = [];
    data?.forEach((item, index) => {
      XAxis.push({
        x: index,
        label: dayjs(item.time).format("MMM DD, HH:mm"),
      });
      valueData.push(
        returnZeroIfInvalidNumber(Number(item.total_cumulative_value)),
      );
    });
    const lastIndex = XAxis.length;
    XAxis.push({
      x: lastIndex,
      label: dayjs().format("MMM DD, HH:mm"),
    });
    valueData.push(returnZeroIfInvalidNumber(value));
    return {
      XAxis,
      valueData,
    };
  }, [data, value]);
  // 判断是否需要显示加载状态
  // const isDataStale = useMemo(() => {
  //   if (isFetching) {
  //     return true;
  //   }
  //   if (!["30d", "90d", "180d"].includes(period.toLocaleLowerCase())) {
  //     return false;
  //   }
  //   if (!data || data.length === 0) {
  //     return false;
  //   }

  //   const lastDataPoint = data.at(-1);
  //   if (!lastDataPoint?.time) {
  //     return false;
  //   }

  //   // 获取昨天0点的UTC时间
  //   const yesterdayStartUTC = dayjs()
  //     .utc()
  //     .subtract(1, "day")
  //     .startOf("day")
  //     .valueOf();

  //   // 判断最后一条数据是否早于昨天0点
  //   return lastDataPoint.time < yesterdayStartUTC;
  // }, [isFetching, data, period]);

  return {
    history,
    setPeriod,
    period,
    isFetching,
  };
};
